/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-05-06 17:07:26
 */
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { formatTree } from '@ithinkdt/shared/utils';

import { ControlValueAccessorService } from '../../control-value-accessor.service';
import { InputFormatterService } from '../../input-formatter.service';
import monitor from '../../monitor';
// import { customInputControlValueAccessor } from '../../../utils/form.utils';

@Component({
  selector: 'dt-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputComponent),
      multi: true,
    },
  ],
})
export class FormInputComponent extends ControlValueAccessorService implements OnInit, OnDestroy, OnChanges {
  passwordVisible = false;
  @Input() type;
  @Input() size = 'default';
  @Input() label = '';
  @Input() placeholder = 'è¯·è¾å¥';
  @Input() itemClass = '';
  @Input() maxl;
  // number
  // æä¸å¼
  @Input() minVal: number;
  // æå¤§å¼
  @Input() maxVal: number;
  @Input() step = 1;
  @Input() prop = '';
  // ç²¾ç¡®åº¦
  @Input() precision = 2;
  // textarea
  // å åæ°
  @Input() rows = 4;
  // æ ¼å¼åï¼æ°å­ï¼
  @Input() formatter: string;
  // è§£æææ¬åç¼
  @Input() beforeSuffix: string;
  // è§£æææ¬åç¼
  @Input() afterSuffix: string;
  @Input() readonly: boolean;
  @Input() setParentValue: (conf, value) => void;
  @Input() conf: any;

  // è¾å¥æ¶
  @Output() vInput = new EventEmitter<any>();

  // æ°å¼æ¹åæ¶
  @Output() valueChange = new EventEmitter<any>();
  @Output() emitModal = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();
  @Output() keyup = new EventEmitter<any>();

  constructor(private inputFormatSrv: InputFormatterService, private changeDetectorRef: ChangeDetectorRef) {
    super();
  }
  ngOnChanges(changes): void {
    if (changes.prop && changes.prop.currentValue) {
      this.changeDetectorRef.detectChanges();
    }
  }
  ngOnInit() {}
  ngOnDestroy(): void {}

  input(e) {
    monitor.emit('formValueChange', this.prop);
    this.vInput.emit(e.target.value);
  }

  inputChange(e) {
    monitor.emit('formValueChange', this.prop);
    this.valueChange.emit(e);
    this.updateChanges();
    if (this.setParentValue) {
      this.setParentValue(this.conf, e);
    }
  }
  buttonChange(e) {
    monitor.emit('formValueChange', this.prop);
    this.emitModal.emit();
  }
  inputBlur(evt) {
    monitor.emit('formValueChange', this.prop);
    this.blur.emit(evt);
  }
  onKeyup(evt) {
    monitor.emit('formValueChange', this.prop);
    this.keyup.emit(evt);
  }

  formatAddSuffix = (val: number) => {
    const value = !isNaN(val) ? val.toFixed(this.precision) : (0).toFixed(this.precision);
    if (this.beforeSuffix) {
      return `${this.beforeSuffix} ${value}`;
    } else if (this.afterSuffix) {
      return `${value} ${this.afterSuffix}`;
    }
    return value;
  };
  parserAddSuffix = (val: string) => {
    if (this.afterSuffix) {
      val = val.replace(this.afterSuffix, '');
    }
    if (this.beforeSuffix) {
      val = val.replace(this.beforeSuffix, '');
    }
    return val.trim();
  };

  // ç¾åæ°
  formatPercent = (val: number | string) => (val || val === 0 || val === '0' ? `${val} %` : '');
  parserPercent = (val: string) => val.replace(' %', '');

  // éé¢
  formatMoney = (val: number | string) =>
    val || val === 0 || val === '0' ? this.inputFormatSrv.userToFixed(val, 2) : '';
  parserMoney = (val: string) => val;

  // ç¾åä½
  formatPercentile = (val: number | string) =>
    val || val === 0 || val === '0' ? this.inputFormatSrv.toPercentile(val) : '';
  parserPercentile = (val: string) => val.replace(/,/g, '');

  nzFormatterDefault: (value: number) => string | number = (value) => value;

  // é»è®¤ç
  nzParserDefault = (value: string) =>
    value
      .trim()
      .replace(/ã/g, '.')
      .replace(/[^\w\.-]+/g, '');
  // ééæ ¼å¼å
  weigthKGFormat = (value: number) => {
    return `${value ? value.toFixed(2) : '0.00'} kg`;
  };
  weigthParserKG = (value: string) => {
    return value.replace('kg', '');
  };
}
